if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: true
    });

     //email signup animation 
	if(document.getElementById('email-signup')){
		document.getElementById('email-signup_first_name').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})
		document.getElementById('email-signup_last_name').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})
		document.getElementById('email-signup_email_address').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})

	}

    //CMS forms label animation
	if(document.getElementsByClassName('form-module__field').length > 0){
		let allffields = document.getElementsByClassName('form-module__field');
		
        for(let j = 0; j < allffields.length; j++){
            
            if(allffields[j].getElementsByTagName('input').length > 0){
                if(allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'checkbox' && allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'radio'){
                    allffields[j].getElementsByTagName('input')[0].addEventListener('focus', function(){
                        this.parentElement.classList.add('moved');
                    })
                }
            }
            if(allffields[j].getElementsByTagName('select').length > 0){
                allffields[j].getElementsByTagName('select')[0].addEventListener('focus', function(){
                    this.parentElement.classList.add('moved');
                })
            }
            if(allffields[j].getElementsByTagName('textarea').length > 0){
                allffields[j].getElementsByTagName('textarea')[0].addEventListener('focus', function(){
                    this.parentElement.classList.add('moved');
                })
            }
        }
	}

    if(document.querySelectorAll('.js-open-menu')){
        document.querySelectorAll('.js-open-menu').forEach(function(element){
            element.addEventListener('click', function(){
                document.getElementById('menu-site').classList.add('show');
            });
        });
    }

    if(document.querySelector('.js-close-menu')){
        document.querySelector('.js-close-menu').addEventListener('click', function(){
            document.getElementById('menu-site').classList.remove('show');
        });
    }

    if(document.querySelectorAll('.js-open-booking')){
        document.querySelectorAll('.js-open-booking').forEach(function(element){
            element.addEventListener('click', function(){
                document.getElementById('booking-widget').classList.add('show');
            });
        });
    }

    if(document.querySelector('.js-close-booking')){
        document.querySelector('.js-close-booking').addEventListener('click', function(){
            document.getElementById('booking-widget').classList.remove('show');
        });
    }

    $('.gallery-quad__slider').slick({
        arrows: true,
        slidesToShow: 1,
        infinite: true,
        centerMode: true,
        variableWidth: true,
        accessibility: true,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    arrows: false
                }
            }
        ]
    });

    console.log($('.gallery-quad__slider').slick('slickGetOption','arrows'));

    let tabsFeatured = document.querySelectorAll('.featured-items__tabs li');
    let itemFeatured = document.querySelectorAll('.featured-items__item');
    
    if(tabsFeatured){
        tabsFeatured.forEach(function(element){
            element.addEventListener('click', function(e){
                let data = e.target.dataset.index;
                let srcImage = e.target.dataset.src;
                document.querySelector('.featured-items__container').style.background = `url('${srcImage}')`;
                tabsFeatured.forEach(function(item){
                    item.classList.remove('active');
                });
                element.classList.add('active');            
                itemFeatured.forEach(function(content){
                    if(content.dataset.index == data){
                        content.classList.add('active');
                    }else{
                        content.classList.remove('active');
                    }
                })
            })
        });
        if(document.querySelectorAll('.featured-items__tabs li').length > 0){
            tabsFeatured[0].click();
        }
    }

    $('.slider__slider').on('init', function () {
        $('[data-slick-goto] button').attr('tabindex', -1);
    });    
    
    $('.slider__slider').slick({
        arrows: false,
        dots: false,
        infinite: true,
        speed: 600,
        fade: true,
        accessibility: true,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    dots: true,
                    adaptiveHeight: true
                }
            }
        ]
    });

    $('.images-slides').slick({
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 3000,
        speed: 700,
        fade: true,
        accessibility: true
    });

    if(window.innerWidth > 760){
        $('.slider__slider [data-slick-goto]').click(function () {
            const $curSlider = $(this).data("target") ? $($(this).data("target")) : $(this).closest('.slider__slider');
            const target = $(this).data("slick-goto") ? parseInt($(this).data("slick-goto")) : 0;
            $curSlider.slick("slickGoTo", target);
        });
    }

    $('.slider-two__slider').slick({
        arrows: false,
        dots: false,
        infinite: true,
        speed: 600,
        fade: true,
        accessibility: true
    });

    $('.slider-two__slider [data-slick-goto]').click(function () {
        const $curSlider2 = $(this).data("target") ? $($(this).data("target")) : $(this).closest('.slider-two__slider');
        const target = $(this).data("slick-goto") ? parseInt($(this).data("slick-goto")) : 0;
        $curSlider2.slick("slickGoTo", target);
    });


    if(document.getElementById('home')){
        function time(){
            let hoursLocal = new Date();
            let hour = hoursLocal.getHours();
            let minutes = hoursLocal.getMinutes();
            document.getElementById('time-local').innerHTML= (hour > 12 ? hour - 12: hour) +':'+ (minutes < 10?'0'+minutes:minutes) + (hour > 12 ?'pm':'am');
        }
        time();
        setInterval(() => { time();},20000);
    }

    if(document.querySelector('.map-points')){
        let points = document.querySelectorAll('.map-point');
        let contentPoint = document.querySelectorAll('[data-point]');
        points.forEach(function(element){
            element.addEventListener('click', function(e){
                let data = e.target.dataset.point;
                contentPoint.forEach(function(item){
                    item.classList.toggle('active',item.dataset.point == data);
                })
            })
        });
    }

    //FAQ
    let tabLabel = document.querySelectorAll('.tab-label');
    if(tabLabel){
        tabLabel.forEach(entry => {
            let thisHeightTap = entry.clientHeight;
            let thisHeight = entry.nextElementSibling.clientHeight + thisHeightTap;
            entry.parentElement.style.height = thisHeightTap+'px';
            if(entry.classList.contains('open')){
                entry.parentElement.style.height = thisHeight+'px';
            }
            entry.addEventListener('click', function(event){
                let currentclick = this;
                if(!this.classList.contains('open')){
                    tabLabel.forEach(ent => {
                        if(ent !== currentclick){
                            if(ent.classList.contains('open')){
                                ent.classList.remove('open');
                                ent.parentElement.style.height = thisHeightTap+'px';
                            }
                        }
                    });
                    this.classList.add('open');
                    this.parentElement.style.height = thisHeight+'px';
                } else {
                    this.classList.remove('open');
                    this.parentElement.style.height = thisHeightTap+'px';
                }
            });
        });
    }

    /*MOBILE MENU NAV
	****************************************************************/

    let Html = document.getElementsByTagName('html')[0];
    let MenuBtn = document.getElementById('menu-btn');
    let CloseMenu = document.querySelectorAll('.close-menu');
    let Navigation = document.querySelectorAll('.navigation');
    let NavUl = document.querySelectorAll('.navigation .inner ul li');
    let NavA = document.querySelectorAll('.navigation .inner ul li a');
    let NavActive = document.querySelectorAll('.navigation ul.submenu li .active');

    //Open Navigation
    if(MenuBtn){
        MenuBtn.addEventListener('click', function(e){
            Html.classList.add('hide-overflow');
            Navigation[0].classList.add('open');
            NavUl.forEach(function(inner) {
                if(inner.classList.contains('item-open')){
                    inner.scrollIntoView(false);
                }
            });
        });

        // Sub-Navigation
        // Open active sub-nav on load
        NavActive.forEach(function(inner) {
            inner.closest('.inner').classList.add('open');
            inner.parentNode.parentNode.parentNode.parentNode.classList.add('item-open');
            inner.closest('.sub-sub-menu').classList.add('menu-open');
        });

        //Toggle open/close on tap
        NavA.forEach(function(entry) {
            if(entry.nextElementSibling){
                let clientHeight = entry.nextElementSibling.querySelector('.submenu').clientHeight;
                if(entry.classList.contains('active') || entry.classList.contains('parent-active')){
                    entry.nextElementSibling.classList.add('menu-open');
                    entry.nextElementSibling.style.height = clientHeight+'px';
                }
                entry.addEventListener('click', function(e){
                    e.preventDefault();
                    if(this.nextElementSibling.classList.contains('menu-open')){
                        this.nextElementSibling.classList.remove('menu-open');
                        this.nextElementSibling.style.height = '0px';
                    } else {
                        NavUl.forEach(function(ul) {
                            if(ul.querySelector('.sub-sub-menu')){
                                if(ul.querySelector('.sub-sub-menu').classList.contains('menu-open')){
                                    ul.querySelector('.sub-sub-menu').style.height = '0px';
                                    ul.querySelector('.sub-sub-menu').classList.remove('menu-open');
                                }
                            }
                        });
                        this.nextElementSibling.classList.add('menu-open');
                        this.nextElementSibling.style.height = clientHeight+'px';
                    }
                });
            }
        });
    }

    //Close Navigation
    if(CloseMenu[0]){
        CloseMenu[0].addEventListener('click', function(e){
            Html.classList.remove('hide-overflow');
            Navigation[0].classList.remove('open');
        });
    }

    let notCharge = document.querySelectorAll('.not-charge');
    if (notCharge){
        notCharge.forEach(entry => {
            entry.addEventListener('click', function(event){
                event.preventDefault();
            });
        });
    }

})();